import { minutesToTime } from '../minutesToTime';

export function getCapacityTime(itemCapacity) {
    if (!itemCapacity) {
        return;
    }
    const capacity = itemCapacity.available - itemCapacity.absence - itemCapacity.planned;
    return minutesToTime(capacity);
}
